import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToAnchor = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // if not a hash link, scroll to top
        if (!hash) {
            window.scrollTo(0, 0);
            return;
        }

        // if hash link, try to scroll
        const scrollToElement = () => {
            const id = hash.replace('#', '');
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        };

        // Attempt to scroll immediately, and then again after a short delay
        // to ensure content is rendered.
        scrollToElement();
        const timer = setTimeout(scrollToElement, 100);

        return () => clearTimeout(timer);
    }, [pathname, hash]);

    return null;
};

export default ScrollToAnchor;
